import { contexts } from '@/domains'
import useFormatData from '@/domains/hooks/useFormatData'
import {
  CaretDownOutlined,
  CaretUpOutlined,
  FolderOpenOutlined,
  PlusOutlined,
  ReloadOutlined,
  UserSwitchOutlined
} from '@ant-design/icons'
import {
  Button,
  Checkbox,
  Col,
  DatePicker,
  Row,
  Select,
  Space,
  Tag
} from 'antd'
import { observer } from 'mobx-react-lite'
import dayjs from 'dayjs'
import moment from 'moment'
import { useState } from 'react'
import Add from './Add'
import styles from './filter.module.less'
import sortBy from 'lodash/sortBy'
import { IconFont } from '@/common'

const { BugContext, UserContext, GlobalContext } = contexts
const Filter = (props) => {
  const { store } = props
  const { onlyFridayAvailable } = useFormatData()
  const { currentDate, handleDateChange, getList } = BugContext.useContainer()
  const { userInfos, userRecord } = UserContext.useContainer()
  const { userInfo: gUserInfo } = GlobalContext.useContainer()
  const [showAdd, setShowAdd] = useState(false)
  const sortConf = [
    {
      key: 'task',
      label: '周交付'
    },
    {
      key: 'reporter',
      label: '提报人'
    },
    {
      key: 'follower',
      label: '跟进人'
    },
    {
      key: 'status',
      label: '状态'
    }
  ]
  const selectedUserMap = {}
  store.userList.forEach((user) => (selectedUserMap[user] = true))
  const selectUserInfo = sortBy(
    (userInfos || []).filter((userInfo) => !selectedUserMap[userInfo.id]),
    (user) => (user.userId === gUserInfo.id ? 0 : 1)
  )

  return (
    <div className={styles.container}>
      <Space className="w-full bug-filter-container" size={15} direction="vertical">
        <Row justify="space-between">
          <Col>
            <Space size={10}  className='date-pick'>
              <IconFont type='icon-riqifanwei1'style={{fontSize:20, marginRight:15, paddingLeft:10,  lineHeight:'16px'}} />
              <DatePicker 
                value={currentDate ? dayjs(currentDate) : undefined}
                format="YYYY-MM-DD ddd"
                disabledDate={onlyFridayAvailable}
                inputReadOnly
                onChange={(date) => {
                  if (date != null && date.day() !== 5) {
                    return
                  }
                  handleDateChange(
                    date ? moment(date.format('YYYY-MM-DD')) : undefined,
                  )
                }}
                className='date-picker' 
              />
              <Button
                onClick={() => {
                  handleDateChange(
                    ((currentDate && moment(currentDate)) || moment())
                      .subtract(1, 'weeks')
                      .isoWeekday(5)
                  )
                }}
              >
                上周
              </Button>
              <Button
                onClick={() => {
                  handleDateChange(
                    ((currentDate && moment(currentDate)) || moment())
                      .add(1, 'weeks')
                      .isoWeekday(5)
                  )
                }}
              >
                下周
              </Button>
              <Button
                onClick={() => {
                  handleDateChange()
                }}
              >
                未排期
              </Button>
            </Space>
          </Col>
          <Col>
            <Space size={10}>
              {/* <Button
              icon={<UserSwitchOutlined />}
              onClick={() => {
                store.visualMode = store.visualMode === 'bug' ? 'person' : 'bug'
              }}
            >
              {store.visualMode === 'bug' ? '列表视角' : '人员视角'}
            </Button> */}
              <Button
                type="primary"
                icon={<PlusOutlined />}
                onClick={() => setShowAdd(true)}
              >
                新增缺陷
              </Button>
            </Space>
          </Col>
        </Row>
        <Row justify='space-between' gutter={[10,10]}>
           <Col>
              <Space size={10} >
                    <IconFont type='icon-shaixuan1' className='date-picker' style={{fontSize:20, marginRight:15, paddingLeft:10, paddingTop:3, lineHeight:'16px'}} />
                    <Checkbox
                      value={store.onlyNotFix}
                      onChange={(e) => {
                        store.onlyNotFix = e.target.checked
                      }}
                    >
                      只看未修复
                    </Checkbox>
                    <Checkbox
                      value={store.onlyMyReport}
                      onChange={(e) => {
                        store.onlyMyReport = e.target.checked
                      }}
                    >
                      只看我提的
                    </Checkbox>
                      跟进人:
                    <Select
                      showSearch
                      mode="multiple"
                      placeholder="选择跟进人"
                      filterOption={(input, option) =>
                        `${userRecord[option.value].userName}${
                          userRecord[option.value].userNamePinyin
                        }${userRecord[option.value].nickname}${
                          userRecord[option.value].userNamePinyin
                        }`
                          .toLowerCase()
                          .includes(input.toLowerCase())
                      }
                      bordered={false}
                      className='member-select-input'
                      value={store.userList}
                      onChange={(e) => {
                        store.userList = e
                      }}
                      tagRender={(p) => {
                        return (
                          <Tag
                            closable
                            onClose={(e) => {
                              store.userList = store.userList.filter(
                                (i) => i !== p.value
                              )
                            }}
                            onMouseDown={(e) => {
                              e.preventDefault()
                              e.stopPropagation()
                            }}
                          >
                            {userRecord[p.value]?.userName}
                          </Tag>
                        )
                      }}
                    >
                      {selectUserInfo.map((userInfo) => (
                        <Select.Option
                          key={userInfo.id}
                          value={userInfo.id}
                          label={userInfo.userName}
                        >
                          {userInfo.userName}
                        </Select.Option>
                      ))}
                    </Select>
              </Space>
           </Col>
        </Row>
        <Row justify="space-between" gutter={[10, 10]}>
          <Col className='sort-options'>
            <Space size={10} className='sort-options'>
              <IconFont type='icon-icon-' style={{fontSize:20, marginRight:15, paddingLeft:10,  marginTop:'3px'}}/>
              {sortConf.map((item) => {
                const isCurrent = store.sortField === item.key
                return (
                  <Button
                    type='text'
                    key={item.key}
                    onClick={() => {
                      if (isCurrent) {
                        store.isAsc = !store.isAsc
                      } else {
                        store.sortField = item.key
                      }
                    }}
                  >
                    <span>{item.label}</span>
                    {isCurrent ? (
                      !!store.isAsc ? (
                        <CaretUpOutlined />
                      ) : (
                        <CaretDownOutlined />
                      )
                    ) : (
                      <></>
                    )}
                  </Button>
                )
              })} 
            </Space>
          </Col>
          <Col>
            <span style={{marginRight:20}}> 共{store.innerList.length || 0}条</span>

            <Button 
              icon={<FolderOpenOutlined />}
              onClick={(e) => {
                // @ts-ignore
                window.emitGlobalEvent('bugFolderAll')
              }}
              className='btn-refresh'
            >
              折叠
            </Button>
            <Button 
              icon={<ReloadOutlined />}
              onClick={getList}
              className='btn-refresh'
            >
              刷新
            </Button>
          </Col>
        </Row>
        <Add visible={showAdd} setVisible={setShowAdd}></Add>
      </Space>
    </div>
  )
}

export default observer(Filter)
